export default __webpack_public_path__ + "static/media/clock-ticks.c1e05fc9.svg";